module.exports = __webpack_public_path__ + "img/jagopack-inactive.1205f448.svg";